import { configureStore } from '@reduxjs/toolkit'
import accessCodeReducer from './pages/access-code-page/accessCodeReducer'
import isCustomReducer from './isCustomReducer'
// ...

const store = configureStore({
    reducer: {
        accessCode: accessCodeReducer,
        isCustom: isCustomReducer,
    },
})

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch